import React from 'react'
import EventData from '../components/EventData';

const EditEventData = () => {
  return (
    <div style={{padding: '10px'}}>
      <EventData />
    </div>
  )
}

export default React.memo(EditEventData)